import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ff/debrief/store';
import { Segment } from 'ff/debrief/models';

export interface AppSliceState {
    toast?: {
        isOpen: boolean;
        message: string;
    };
    isHidingScoreDetails?: boolean;
    isShareApp?: boolean;
    isChartOpen?: boolean;
    isDecluttering?: boolean;
    tracklogFilter?: {
        startDate: number | null;
        endDate: number | null;
        fuzzySearchTerm: string | null;
    };
    selectedSegment?: Segment | null;
}

export const initialAppSliceState: AppSliceState = {
    toast: {
        isOpen: false,
        message: '',
    },
    isHidingScoreDetails: false,
    isShareApp: false,
    isChartOpen: true,
    isDecluttering: false,
    tracklogFilter: {
        startDate: null,
        endDate: null,
        fuzzySearchTerm: '',
    },
    selectedSegment: null,
};

export const appSlice = createSlice({
    name: 'AppSlice',
    initialState: initialAppSliceState,
    reducers: {
        setToastState: (state, action: PayloadAction<boolean>) => {
            state.toast.isOpen = action.payload;
        },
        setToastMessage: (state, action: PayloadAction<string>) => {
            state.toast.message = action.payload;
        },
        setFilterStartDate: (state, action: PayloadAction<number>) => {
            const currentStartDate = state.tracklogFilter.startDate;
            const currentEndDate = state.tracklogFilter.endDate;
            const newStartDate = action.payload;
            if (currentEndDate) {
                state.tracklogFilter.startDate =
                    newStartDate > currentEndDate
                        ? currentStartDate
                        : newStartDate;
            } else {
                state.tracklogFilter.startDate = newStartDate;
            }
        },
        setHideScoreDetails: (state, action: PayloadAction<boolean>) => {
            state.isHidingScoreDetails = action.payload;
        },
        setDecluttering: (state, action: PayloadAction<boolean>) => {
            state.isDecluttering = action.payload;
        },
        setFilterEndDate: (state, action: PayloadAction<number>) => {
            const currentStartDate = state.tracklogFilter.startDate;
            const currentEndDate = state.tracklogFilter.endDate;
            const newEndDate = action.payload;
            if (currentStartDate) {
                state.tracklogFilter.endDate =
                    newEndDate < currentStartDate ? currentEndDate : newEndDate;
            } else {
                state.tracklogFilter.endDate = newEndDate;
            }
        },
        setChartOpen: (state, action: PayloadAction<boolean>) => {
            state.isChartOpen = action.payload;
        },
        setFuzzySearchTerm: (state, action: PayloadAction<string>) => {
            state.tracklogFilter.fuzzySearchTerm = action.payload;
        },
        setSelectedSegment: (state, action: PayloadAction<Segment>) => {
            state.selectedSegment = action.payload;
        },
    },
});

export const actions = appSlice.actions;

export const selectFilterStartDate = (state: RootState) =>
    state.appSlice.tracklogFilter.startDate;
export const selectFilterEndDate = (state: RootState) =>
    state.appSlice.tracklogFilter.endDate;
export const selectFuzzySearchTerm = (state: RootState) =>
    state.appSlice.tracklogFilter.fuzzySearchTerm;
